import {BasePage} from '../utils/base';
import {Store} from '../utils/store';
import {CountriesHelper} from '../utils/countries';
import '../css/login.scss';
import {findPhonePrefix, findCountry, findPhoneNumber, formatPhone} from '../utils/helper';

export let countryHelper = new CountriesHelper();

export class LoginPage extends BasePage {
  view: HTMLElement;
  phoneInput: HTMLInputElement;

  dropdownContainer: HTMLElement;
  dropdownInput: HTMLInputElement;
  dropdownCountries: HTMLElement;
  dropdownIcon: SVGElement;
  dropdownCountriesContainer: HTMLElement;
  dropdownItemTemplate: HTMLElement;
  button: HTMLElement;
  checkbox;

  constructor() {
    super();

    this.storeHelper.subscribe(
      ['selectedCountry', 'countrySearchStr', 'hoveredCountry', 'showCountriesDropdown'],
      this.updateDropdown,
    );
    this.storeHelper.subscribe(['countriesList'], this.renderDropdownItems);
    this.storeHelper.subscribe(['phonePrefix', 'phoneNumber', 'rawPhoneValue'], this.updatePhone);
    this.storeHelper.subscribe(['phonePrefix', 'phoneNumber', 'selectedCountry'], this.updateButton);

    let viewTemplate = this.templates.querySelector('.login') as HTMLElement;
    this.dropdownItemTemplate = this.templates.querySelector('.dropdown-item') as HTMLElement;

    this.setPage(viewTemplate.cloneNode(true) as HTMLElement);

    this.view = this.app.querySelector('.login') as HTMLElement;

    this.checkbox = this.view.querySelector('[type="checkbox"]');
    this.checkbox.addEventListener('change', () => {
      this.storeHelper.setStore({keepMeSign: this.checkbox.checked});
    });

    let submit = () => {
      if (loading) {
        return;
      }
      loading = true;
      this.dropdownInput.classList.add('disabled');
      this.phoneInput.classList.add('disabled');

      this.button.classList.add('loading');

      this.apiHelper.setPhoneNumber(`+${this.storeHelper.store.rawPhoneValue}`).catch(() => {
        loading = false;
        this.dropdownInput.classList.remove('disabled');
        this.phoneInput.classList.remove('disabled');

        this.button.classList.remove('loading');

        this.phoneInput.classList.add('wrong');
      });      
    };

    this.phoneInput = this.view.querySelector('.phone') as HTMLInputElement;
    this.phoneInput.addEventListener('keyup', this.phoneChange);
    this.phoneInput.addEventListener('keypress', (event) => {
      if (event.keyCode == 13 && this.updateButton(this.storeHelper.store)) {
        submit();
      }
    });

    this.dropdownContainer = this.view.querySelector('.dropdown') as HTMLElement;
    this.dropdownInput = this.view.querySelector('.dropdown input') as HTMLInputElement;
    this.dropdownCountries = this.view.querySelector('.dropdown-countries') as HTMLElement;
    this.dropdownCountriesContainer = this.dropdownCountries.querySelector('.dropdown-container') as HTMLElement;
    this.dropdownIcon = this.view.querySelector('.dropdown-icon') as SVGElement;

    let loading = false;
    this.button = this.view.querySelector('button') as HTMLElement;
    
    this.addLoading('.button-loading', this.button);

    this.button.addEventListener('click', submit);

    this.dropdownInput.addEventListener('keyup', this.dropdownChange);

    let prevent = false;

    this.dropdownInput.addEventListener('focus', () => {
      let rect = this.dropdownContainer.getBoundingClientRect();
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      let top = rect.top + 64 + scrollTop;
      let height = document.body.clientHeight - top - 20;
      if (height < 200) {
        height = 250;
      }

      this.dropdownCountries.style.left = `${rect.left}px`;
      this.dropdownCountries.style.top = `${top}px`;

      this.dropdownCountries.style.display = 'block';
      this.dropdownCountries.style.maxHeight = `${height}px`;
      this.dropdownCountriesContainer.style.maxHeight = `${height - 20}px`;

      let countriesList = countryHelper.search(this.storeHelper.store.countrySearchStr);

      this.storeHelper.setStore({showCountriesDropdown: true, countriesList});
    });

    this.dropdownInput.addEventListener('blur', () => {
      prevent = true;
      this.storeHelper.setStore({showCountriesDropdown: false, hoveredCountry: undefined});
      this.dropdownCountries.style.display = 'none';
    });

    this.dropdownIcon.addEventListener('click', () => {
      if (prevent) {
        prevent = false;
        return;
      }

      let newValue = !this.storeHelper.store.showCountriesDropdown;
      this.storeHelper.setStore({showCountriesDropdown: newValue});

      if (newValue) {
        this.dropdownInput.focus();
      }
    });

    this.dropdownCountriesContainer.addEventListener('mousemove', (event: MouseEvent) => {
      let target = event.target as HTMLElement;
      let item = target.closest('.dropdown-item');

      if (item) {
        let code = item.getAttribute('country');
        let country = countryHelper.getByCode(code as string);

        if (country) {
          this.storeHelper.setStore({hoveredCountry: country});
        }
      }
    });

    this.dropdownCountriesContainer.addEventListener('mouseout', (event: MouseEvent) => {
      this.storeHelper.setStore({hoveredCountry: undefined});
    });

    this.dropdownCountriesContainer.addEventListener('mousedown', (event: MouseEvent) => {
      let target = event.target as HTMLElement;
      let item = target.closest('.dropdown-item');

      if (item) {
        let code = item.getAttribute('country');
        let country = countryHelper.getByCode(code as string);

        if (country) {
          this.storeHelper.setStore({
            selectedCountry: country,
            phonePrefix: country[3],
            hoveredCountry: undefined,
            countrySearchStr: '',
          });

          requestAnimationFrame(() => {
            this.phoneInput.focus();
          });
        }
      }
    });

    if (this.storeHelper.store.selectedCountry) {
      this.updateDropdown(this.storeHelper.store);
      this.updatePhone(this.storeHelper.store);
      this.updateButton(this.storeHelper.store);
      return;
    }

    fetch('https://api.ipstack.com/check?access_key=a0d893df62374044786a34a9b0e6692e&fields=country_code')
      .then(res => res.json())
      .then(data => {
        let code = data && data.country_code;

        if (code) {
          let country = countryHelper.getByCode(code);
          let userInteract = this.storeHelper.store.userInteract;

          if (country && !userInteract) {
            this.storeHelper.setStore({
              selectedCountry: country,
              phonePrefix: country[3],
              rawPhoneValue: country[3],
            });
          }
        }
      });
  }

  renderDropdownItems = () => {
    let countriesList = countryHelper.search(this.storeHelper.store.countrySearchStr);

    if (!countriesList.length) {
      this.dropdownCountriesContainer.classList.add('empty');
      return;
    }

    this.dropdownCountriesContainer.classList.remove('empty');

    this.dropdownCountriesContainer.innerHTML = '';
    countriesList.forEach(country => {
      let item = this.dropdownItemTemplate.cloneNode(true) as HTMLElement;
      item.setAttribute('country', country[0]);

      let flag = item.querySelector('.country-flag') as HTMLElement;
      flag.innerHTML = country[1];

      let name = item.querySelector('.country-name') as HTMLElement;
      name.innerHTML = country[2];

      let code = item.querySelector('.country-code') as HTMLElement;
      code.innerHTML = country[3];

      this.dropdownCountriesContainer.appendChild(item);
    });
  };

  updateDropdown = (store: Store) => {
    this.dropdownInput.classList.remove('hovered');
    this.dropdownInput.classList.remove('value');
    this.dropdownContainer.classList.remove('open');

    if (store.showCountriesDropdown) {
      this.dropdownInput.classList.add('hovered');
      this.dropdownContainer.classList.add('open');

      if (store.hoveredCountry || store.countrySearchStr) {
        this.dropdownInput.classList.add('value');
      }

      this.dropdownInput.value = store.countrySearchStr;
      if (store.hoveredCountry) {
        this.dropdownInput.value = store.hoveredCountry[2];
      }
    } else if (store.selectedCountry) {
      this.dropdownInput.classList.add('value');
      this.dropdownInput.value = store.selectedCountry[2];
    } else {
      this.dropdownInput.classList.add('hovered');
      this.dropdownInput.value = 'Unknown';
    }
  };

  dropdownChange = () => {
    let value = this.dropdownInput.value;
    let countriesList = countryHelper.search(value);

    this.storeHelper.setStore({
      countrySearchStr: this.dropdownInput.value,
      userInteract: true,
      countriesList,
      hoveredCountry: undefined,
    });
  };

  phoneChange = () => {
    let value = this.phoneInput.value;
    let {phonePrefix, selectedCountry, phoneNumber} = this.storeHelper.store;

    let newPhonePrefix = '';
    let newPhoneNumber = '';
    let newSelectedCountry;

    let clearValue = this.clearPhoneValue(value);

    if (clearValue) {
      newPhonePrefix = findPhonePrefix(clearValue, selectedCountry!, countryHelper);
    }

    if (newPhonePrefix) {
      newSelectedCountry = findCountry(newPhonePrefix, selectedCountry!, countryHelper);
    }

    if (newPhonePrefix && clearValue.length > newPhonePrefix.length) {
      newPhoneNumber = findPhoneNumber(clearValue, newPhonePrefix);
    } else {
      newPhoneNumber = '';
    }

    let newStore: Pick<Store, any> = {};

    if (phonePrefix !== newPhonePrefix) {
      newStore.phonePrefix = newPhonePrefix;
    }

    if (selectedCountry !== newSelectedCountry) {
      newStore.selectedCountry = newSelectedCountry;
    }

    if (phoneNumber !== newPhoneNumber) {
      newStore.phoneNumber = formatPhone(newPhoneNumber);
    }

    newStore.rawPhoneValue = value.replace(/[^0-9]/g, '');
    newStore.userInteract = true;

    this.storeHelper.setStore(newStore);
  };

  clearPhoneValue(value: string): string {
    let numbers = value.replace(/\D/g, '');
    if (numbers) {
      return `+${numbers}`;
    } else {
      return '';
    }
  }

  updatePhone = (store: Store) => {
    let {phonePrefix, phoneNumber, rawPhoneValue} = store;

    if (phonePrefix && phoneNumber) {
      this.phoneInput.value = `${phonePrefix} ${phoneNumber}`;
    } else if (phonePrefix) {
      this.phoneInput.value = phonePrefix;
    } else {
      this.phoneInput.value = rawPhoneValue;
    }

    if (this.phoneInput.value) {
      this.phoneInput.classList.add('value');
    } else {
      this.phoneInput.classList.remove('wrong');
      this.phoneInput.classList.remove('value');
    }
  };

  updateButton = (store: Store) => {
    let {selectedCountry, phonePrefix, phoneNumber} = store;

    let button = this.view.querySelector('.next-button') as HTMLElement;

    if (selectedCountry && phonePrefix && phoneNumber && this.clearPhoneValue(phonePrefix + phoneNumber).length >= 7) {
      button.style.display = 'block';
      return true;
    } else {
      button.style.display = 'none';
      return false;
    }
  };
}
